<template>
    <div>
      <ssams-write-link
        v-for="writeLayout in writeLayouts"
        :key="`ssams${writeLayout}`"
        :writeLayout="writeLayout"
        :ssamsData="ssamsData"
        :ssamsSnsData = "ssamsSnsList"
        :profileFiles="files"
      ></ssams-write-link>
    </div>
  </template>
  
  <script>
  import SsamsWriteLink from "@/components/ssams/link/SsamsWriteLink";
  import ssamsUtil from "@/components/ssams/ssamsUtil";
  import EventBus from "@/utils/event-bus";
  import util from "@/mixins/util";
  import alertMixins from "@/mixins/alertMixins";
  import ssamsValidator from "@/components/ssams/ssamsValidator";
  import DeleteClass from "@/mixins/deleteClass";
  import elFileMixins from "@/mixins/elFileMixins";
  
  export default {
    name: "SsamsWriteComponent",
    mixins: [alertMixins, ssamsUtil, elFileMixins, ssamsValidator],
    components: { SsamsWriteLink },
    inject: [],
    provide() {
      return {
        ssamsWriteSetData: this.setData,
      };
    },
    props: {
      ssamsType: { default: "" },
      ssamsKey: { default: 0 },
    },
    data() {
      return {
        ssamsData: {},
        getFunc: "",
        detailApiParamSet: {},
  
        isCategory: false,
        getCategoryFunc: "",
  
        writeLayouts: [],
        writeFunc: "",
        writeApiParamSet: {},
        parsingData: {},
        fileType: "",
        directUrl: "",
        directType: "",
        keyName: "",
        writeSuccessType: 1,
        writeSuccessMsg: "작성되었습니다.",
        writeFailTypes: {},
        writeFailMsg: "",
  
        isRunning: false,
  
        deleteFunc: "",
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        DeleteClass: null,
  
        ssamsSnsList: {},
      };
    },
    beforeRouterEnter() {},
    created() {
      this.initFilterConfig();
      this.getSsamsSnsData();
      if (this.ssamsKey === 0) {
        this.initTemplateConfig();
      } else {
        this.getSsams();
      }
    },
    mounted() {
    EventBus.$on("writeSsams", this.writeSsams);
    EventBus.$on("deleteSsams", this.runDeleteConfirm);
    // migration
    // EventBus.$on("migrationSsams", this.migrationSsams);
    
  },
  beforeDestroy() {
    EventBus.$off("writeSsams");
    EventBus.$off("deleteSsams");
        // migration
    // EventBus.$off("migrationSsams");
  },
    destroyed() {},
    computed: {},
    methods: {
      setData(key, value) {
        this[key] = value;
      },
      initTemplateConfig() {
        let config = this.returnSsamsConfig(this.ssamsType);
        this.writeLayouts = config.writeLayouts;
      },
      initFilterConfig() {
        let config = this.returnSsamsConfig(this.ssamsType);
        this.getFunc = config.getFunc;
        this.detailApiParamSet = config.detailApiParamSet;
        this.getCategoryFunc = config.getCategoryFunc;
        this.isCategory = config.isCategory;
        this.writeFunc = config.writeFunc;
        this.writeApiParamSet = config.writeApiParamSet;
        this.parsingData = config.parsingData;
        this.fileType = config.fileType;
        this.directUrl = config.directUrl;
        this.directType = config.directType;
        this.keyName = config.keyName;
        this.writeSuccessType = config.writeSuccessType;
        this.writeSuccessMsg = util.isEmpty(config.writeSuccessMsg)
          ? this.writeSuccessMsg
          : config.writeSuccessMsg;
        this.writeFailTypes = config.writeFailTypes;
        this.writeFailMsg = config.writeFailMsg;
        this.deleteFunc = config.deleteFunc;
        this.deleteApiParamsSet = config.deleteApiParamsSet;
        this.deleteSuccessType = config.deleteSuccessType;
        this.deleteFailTypes = config.deleteFailTypes;
  
        this.newDeleteClass();
        if (this.isCategory) {
          this.getCategory();
        }
      },
      getSsams() {
        let params = Object.assign({}, this.detailApiParamSet);
        params.id = this.ssamsKey;
        EventBus.$emit("apiLoading", true);
        try {
          this.$api.$ssams[this.getFunc](params)
            .then((res) => res.Data.Result)
            .then((res) => {
              if (res.Info.type !== 1 || util.isEmpty(res.List)) {
                this.errorAlert("데이터를 불러올 수 없습니다.");
                this.$router.back();
                return false;
              }
              this.ssamsData = res.List[0];
              EventBus.$emit("apiLoading", false);
              EventBus.$emit("ssamsData", this.ssamsData);
              this.initTemplateConfig();
            });
        } catch (e) {
          console.log(e);
          EventBus.$emit("apiLoading", false);
        }
      },
  
      _checkValidator() {
        let validatorArr = Object.keys(this.parsingData);
        return this.$validate(validatorArr).then((success) => {
          if (!success) {
            this.errorAlert("필수데이터를 확인해주세요.");
            util.Array.each(this.writeLayouts, (layout, index, arr) => {
              EventBus.$emit(`${layout}Validator`, validatorArr);
            });
            return success;
          }
          return success;
        });
      },
      _makeParams() {
        let params = Object.assign({}, this.writeApiParamSet);
        util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
          if (this[dataKey] != this.ssamsData[paramKey]) {
            params[paramKey] = this[dataKey];
          }
        });
  
        if (this.ssamsKey !== 0) {
          params[this.keyName] = this.ssamsKey;
        }
        if(params[this.keyName] == this.ssamsKey){
          params.uuid = this.ssamsData.s_uuid;
        }
  
        return params;
      },
      async writeSsams() {
        if (this.isRunning) {
          return false;
        }
        this.isRunning = true;
  
        let validator = await this._checkValidator();
        if (!validator) {
          this.isRunning = false;
          return false;
        }
  
        EventBus.$emit("apiLoading", true);
        let params = this._makeParams();
  
        try {
          this.$api.$ssams[this.writeFunc](params)
            .then((res) => res.Data.Result)
            .then((res) => {
              let type = this.returnWriteType(res.Info.type);
              if (type !== true) {
                this.errorAlert(type);
                EventBus.$emit("apiLoading", false);
                return (this.isRunning = false);
              }
              if (!util.isEmpty(this.deleteFiles)) {
                this.removeFiles(this.deleteFiles);
              }
  
              this.createOpenChat(this.chatUuid,res.List.s_idx);
              let checkFile =
                !util.isEmpty(this.fileType) &&
                !util.isEmpty(this.files) &&
                this.files.filter((file) => file.hasOwnProperty("raw")).length >
                  0;
              if (checkFile) {
                for(let i = 0; i< this.files.length; i++){
                    this.files[i].a_seq = i;
                }
                let uploadFileList = this.files.filter(item=> !item.a_idx);
                let file_id = "";
                file_id =this.ssamsType === "ssamsUpdate"  ? this.ssamsKey  : res.List.s_idx;
                this.uploadFiles(uploadFileList, this.fileType, file_id).then(success => {
                  this.afterFunc();
                    EventBus.$emit("apiLoading", false);
                });
  
              } else {
                this.afterFunc();
                EventBus.$emit("apiLoading", false);
              }
            });
        } catch (e) {
          console.log(e);
          this.isRunning = false;
          EventBus.$emit("apiLoading", false);
        }
      },
      returnWriteType(type) {
        if (type === this.writeSuccessType) {
          return true;
        } else {
          return util.isEmpty(this.writeFailTypes[type])
            ? "저장 실패했습니다."
            : this.writeFailTypes[type];
        }
      },
      afterFunc() {
        EventBus.$emit("apiLoading", false);
  
        let content = this.ssamsKey === 0 ? "저장하였습니다." : "수정하였습니다.";
        this.createAlert({
          content: content,
          hide: () => {
            if (this.directType === "back") {
              this.$router.back();
              EventBus.$emit("apiLoading", false);
              return false;
            }
            if (this.directUrl === "") {
              this.writeLayouts = [];
              this.deleteFiles = [];
              EventBus.$emit("apiLoading", false);
              return false;
            }
            EventBus.$emit("apiLoading", false);
            let url = this.directUrl;
            this.$router.push(url);
          },
        });
      },
      newDeleteClass() {
        if (!util.isEmpty(this.deleteFunc)) {
          let deleteOptions = {
            func: this.$api.$ssams[this.deleteFunc],
            apiParamSet: this.deleteApiParamsSet,
            keyName: this.keyName,
            successType: this.deleteSuccessType,
            errorTypes: this.deleteFailTypes,
            afterFunc: this.deleteAfterFunc,
          };
          this.DeleteClass = new DeleteClass(deleteOptions);
        }
      },
      runDeleteConfirm() {
        this.createConfirm({
          content: "정말 삭제하시겠습니까?",
          confirmText: "삭제",
          confirm: () => {
            this.runDelete();
          },
        });
      },
      runDelete() {
        EventBus.$emit("apiLoading", true);
        this.DeleteClass.runDelete(this.ssamsKey);
      },
      deleteAfterFunc() {
        this.removeOpenChat(this.ssamsData.s_uuid);
        EventBus.$emit("apiLoading", false);
        this.createAlert({
          content: "삭제가 완료되었습니다.",
          hide: () => {
            this.$router.back();
          },
        });
      },
      createOpenChat(roomId,s_idx) {
        if(roomId == null){
          return
        }
        let $this = this;
        let roomRef = this.$store.state.db.collection("rooms");
        roomRef.doc(roomId).get().then(function (doc) {
          if(!doc.data()){
            let roomData = {
              created: Date.now(),
              updated: Date.now(),
              id: roomId,
              msg: {lastMsg : '',lastName : '',created : '',lastImg : '',},
              roomType: "openChat",
              isQuickRequesting:false,
              roomMaster: $this.memberUuid,
              SsamsNo : s_idx,
            };
            roomRef.doc(roomId).set(roomData,{merge:true})
            .then(function (res) {
                $this.joinOpenChat(roomId,"openChat",$this.memberUuid);
                $this.roomJoinOpenChat(roomId, $this.memberUuid);
                console.log("오픈 챗 생성 완료");
            })
            .catch(function (error) {
                console.log("오픈 챗 생성 오류");
            });
          }
        })
      },
      joinOpenChat(roomId,roomType,userId){
        let createdAt = Date.now();
        let roomdata = {
          id: roomId,
          roomType: roomType,
          created: createdAt,
        };
        this.$store.state.db.collection("users").doc(userId).collection("rooms").doc(roomId).set(roomdata, { merge: true });
      },
      roomJoinOpenChat(roomId,userId){
        let createdAt = Date.now();
        let data =  {
            created: createdAt,
            id: userId,
            alarm: "on",
            updateAt: createdAt,
          }
          this.$store.state.db.collection("rooms").doc(roomId).collection("users").doc(userId).set(data,{ merge: true });
      },
      async removeOpenChat(roomId){
        if(roomId == null){
          return
        }
        let $this = this;
        let roomRef = this.$store.state.db.collection("rooms");
        const snapshot = await roomRef.doc(roomId).collection("users").get();
        snapshot.forEach(doc => {
          $this.removeUserRooms(doc.id,roomId);
        });
      },
      removeUserRooms(userId,roomId){
        const roomRef = this.$store.state.db.collection("users").doc(userId).collection("rooms").doc(roomId);
        roomRef.delete()
        .then(function (res) {
          console.log(userId, "방 폭파로 인해 사라짐")
        })
        .catch(function (error) {
          console.log("Error delete User Room", error);
        });
      },
      getSsamsSnsData() {
        let params = {di : 1, ip:0, sp: 1, page: 1};
        try {
          this.$api.$ssams.getSnsCategory(params).then(res => res.Data.Result).then(res => {
            if (res.Info.type != 1 || util.isEmpty(res.List)) {
              console.log(res.Info.type);
              return false;
            }
            this.ssamsSnsList = res.List
          })
        } catch (e) {
          console.log(e);
        }
      },
      async migrationSsams(){
        let $this = this;
        let roomId = this.ssamsData.s_uuid;
        let ssamsIdx = this.ssamsData.s_idx
        const snapshot = await this.$store.state.db.collection("rooms").doc(roomId).collection("users").get();
        snapshot.forEach(doc => {
          let params = {
          type : 'attend',
          s_idx : ssamsIdx,
          mb_uuid : doc.data().id
        };
          $this.$api.$ssams.userOpenChatJoinStatus(params).then(res=> res.Data.Result).then(res => {})
        });
      },
  },
  watch: {},
};
</script>

<style scoped></style>
